import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { 
  arSA,
  de,
  enUS,
  es,
  frCA,
  fr,
  pl,
  ptBR,
  he,
  hu,
  id,
  ms,
  th,
  vi,
  ko,
  ja,
  zhCN,
  zhTW
} from 'date-fns/locale'
import Backend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import axios from 'axios'

export const supportedLanguages = [
  { lng: 'ar', name: 'عربي', dateFnsLoc: arSA },
  { lng: 'en', name: 'English', dateFnsLoc: enUS },
  { lng: 'de', name: 'Deutsch', dateFnsLoc: de },
  { lng: 'fr', name: 'Français', dateFnsLoc: fr },
  { lng: 'fr-CA', name: 'Français (Canadien)', dateFnsLoc: frCA },
  { lng: 'he', name: 'עִברִית', dateFnsLoc: he },
  { lng: 'hu', name: 'Magyar', dateFnsLoc: hu },
  { lng: 'pl', name: 'Polski', dateFnsLoc: pl },
  { lng: 'pt-BR', name: 'Português (Brasil)', dateFnsLoc: ptBR },
  { lng: 'es', name: 'Español', dateFnsLoc: es },
  { lng: 'id', name: 'Bahasa Indonesia', dateFnsLoc: id },
  { lng: 'ms', name: 'Bahasa Melayu', dateFnsLoc: ms },
  { lng: 'th', name: 'ภาษาไทย', dateFnsLoc: th },
  { lng: 'vi', name: 'Tiếng Việt', dateFnsLoc: vi },
  { lng: 'ko', name: '한국어', dateFnsLoc: ko },
  { lng: 'ja', name: '日本語', dateFnsLoc: ja },
  { lng: 'zh-CN', name: '简体中文', dateFnsLoc: zhCN },
  { lng: 'zh-TW', name: '繁體中文', dateFnsLoc: zhTW },
  ...(process.env.NODE_ENV === 'development'
    ? [{ lng: 'cimode', name: 'Keys (dev)', dateFnsLoc: enUS }]
    : []),
]

export const supportedLanguagesForPubPages = [
  { lng: 'en', name: 'English', dateFnsLoc: enUS },
  { lng: 'de', name: 'Deutsch', dateFnsLoc: de },
  { lng: 'hu', name: 'Magyar', dateFnsLoc: hu },
  { lng: 'pl', name: 'Polski', dateFnsLoc: pl },
  { lng: 'id', name: 'Bahasa Indonesia', dateFnsLoc: id },
  { lng: 'ms', name: 'Bahasa Melayu', dateFnsLoc: ms },
  { lng: 'th', name: 'ภาษาไทย', dateFnsLoc: th },
  { lng: 'vi', name: 'Tiếng Việt', dateFnsLoc: vi },
  { lng: 'ko', name: '한국어', dateFnsLoc: ko },
  { lng: 'ja', name: '日本語', dateFnsLoc: ja },
  { lng: 'zh-CN', name: '简体中文', dateFnsLoc: zhCN },
  { lng: 'zh-TW', name: '繁體中文', dateFnsLoc: zhTW },
  ...(process.env.NODE_ENV === 'development'
    ? [{ lng: 'cimode', name: 'Keys (dev)', dateFnsLoc: enUS }]
    : []),
]

export const getCurrentLangObj = (lng) =>
  supportedLanguages.find((l) => l.lng === lng)

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    // debug: true,
    ns: ['pub'],
    defaultNS: ['priv'],
    interpolation: {
      escapeValue: false,
    },
    transSupportBasicHtmlNodes: true,
    
    supportedLngs: supportedLanguages.map(({ lng }) => lng),
    backend: {
      loadPath: `/mcr/translation/{{ns}}?lng={{lng}}`,
      crossDomain: true,
      withCredentials: true,
      request: async function (options, url, payload, callback) {
        try {
          const { data } = await axios.get(url)
          callback(null, { status: 'ok', data })
        } catch (e) {
          callback(e, null)
          // throw new Error('There was a problem loading the localization file.')
        }
      },
    },
  })

export default i18n
